import appModuleRegistry from "components/appModules/appModuleRegistry";
import { ComponentDefinition } from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import $ from "jquery";
import { I18nMessage } from "components/i18n/I18nMessage";
import "./breadcrumb.scss";
import { initHelpIconlWebComponent } from "./helpIcon";

initHelpIconlWebComponent();
export class Breadcrumb extends ValueBaseComponent<BreadcrumbDefinition> {

    public readonly componentType: string = "breadcrumb";
    private stack: string[] = [];
    private bcHolder: HTMLDivElement;

    constructor(definition: BreadcrumbDefinition) {
        super(definition);
    }

    public render(): Element {
        let jqueryView = $("<div class='c-breadcrumb'></div>");
        this.view = jqueryView[0];
        this.view.insertAdjacentHTML("beforeend", "<div class='c-breadcrumb__bc'></div>");
        this.bcHolder = this.view.querySelector(".c-breadcrumb__bc");
        this.addRoot();
        this.addNode(this.definition.title.toString());
        this.addHelp();
        return this.view;
    }

    private addRoot() {
        let title;
        if (appModuleRegistry.currentApp != null) {
            title = appModuleRegistry.currentApp.title;
        } else {
            title = "SISLOG";
        }
        this.addParent(title);
    }

    public postRender(): void {
        $(".js-stack-holder").on("pageStacked", (evt, component) => {
            this.addNode(component.definition.pageTitle);
        });
        $(".js-stack-holder")[0].addEventListener("breadCrumbUnstackRequested", (evt) => {
            this.popNode();
        });
    }
    private addParent(parentText: string): void {
        this.stack.push(parentText);
        $(
            "<div class='c-breadcrumb__node c-breadcrumb__node-first'><div class='c-breadcrumb__node-text'>"
            + parentText
            + "</div></div>")
            .appendTo($(this.bcHolder) as JQuery<HTMLElement>);
    }

    private addHelp(): void {
        if (appModuleRegistry.currentApp != null && appModuleRegistry.currentApp.helpUrl != null) {
            $("<s6-help-icon helpUrl='" + appModuleRegistry.currentApp?.helpUrl + "'></s6-help-icon>")
                .appendTo($(this.view) as JQuery<HTMLElement>);
        }
    }

    private addNode(nodeText: string): void {
        let text = new I18nMessage(nodeText).toString();
        this.stack.push(text);
        $("<div class='c-breadcrumb__node'><div class='c-breadcrumb__node-text'>" + text + "</div></div>")
            .appendTo($(this.bcHolder) as JQuery<HTMLElement>);
    }

    private popNode() {
        this.stack.pop();
        document.title = this.getSislogTitle(this.stack[this.stack.length - 1]);
        $(this.bcHolder).children(".c-breadcrumb__node:last").remove();
    }

    public getSislogTitle(title: string) {

        let newTitle = title;
        if(!title.startsWith("SISLOG")) {
            newTitle = "SISLOG - " + newTitle;
        }
        return newTitle;
    }

    public static instance(titleKey: string) {
        return new Breadcrumb({
            componentType: "breadcrumb",
            id: "breadcrumb",
            title: titleKey.toString(),
        });
    }
}

export interface BreadcrumbDefinition extends ComponentDefinition {
    title: string | I18nMessage;
}
